export CustomerDetails from './CustomerDetails';
export CustomersSelector from './CustomersSelector';
export ModalEmailAction from './ModalEmailAction';
export ModalFormCustomer from './ModalFormCustomer';
export ReservationExtraInfos from './ReservationExtraInfos';
export ReservationGuestsDetails from './ReservationGuestsDetails';
export ReservationInfo from './ReservationInfo';
export ReservationPricesDetails from './ReservationPricesDetails';
export ReservationRemarksContainer from './ReservationRemarksContainer';



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/common/index.js